import React from "react";
import { Image, View, StyleSheet, ScrollView } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";

function ShowLimitedImages({ imgs = [], limit = 3 }) {
  if (!imgs.length || limit <= 0) {
    return;
  }
  const totalImages = imgs.length;
  const toShowOnlyArr = imgs.slice(0, limit);
  return (
    <ScrollView horizontal contentContainerStyle={styles.imageContainer}>
      {toShowOnlyArr.map((image, imageIndex) => (
        <Image
          resizeMode="contain"
          key={image?.key}
          source={{ uri: image?.product_image }}
          style={styles.image}
        />
      ))}
      {toShowOnlyArr.length < totalImages && (
        <View style={styles.nMoreBox}>
          <Text variant="body_text_4" style={{ color: "rgba(0,0,0,0.56)" }}>
            +{+totalImages - limit}
          </Text>
        </View>
      )}
    </ScrollView>
  );
}

export default ShowLimitedImages;

const styles = StyleSheet.create({
  image: {
    marginRight: 15,
    height: 50,
    width: 50,
    borderWidth: 1,
    borderColor: color.lighterBlack,
    borderRadius: 6,
  },
  nMoreBox: {
    height: 50,
    alignItems: "center",
    justifyContent: "center",
  },
  imageContainer: {
    overflow: "visible",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
});
